export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/calendarBookedCar.c321d825.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};